export const AUTH_KEY = 'auth-token'
export const AUTH_TYPE_KEY = 'auth-type'
export const OAUTH_PATH_DATA_KEY = 'oauth-path-data'
export const STORE_ID_KEY = 'selected-store'
export const PICK_DISPLAY_PREFERENCE_KEY = 'pick-display-preference'
export const VIEWED_SESSIONS_KEY = 'viewed-sessions'